import React from 'react';
import { Button } from '@material-ui/core';

const ColoredButton = props => {
  const { color, style, ...rest } = props;
  return (
    <Button
      {...rest}
      variant="outlined"
      style={{ color, borderColor: color, ...style }}
    />
  );
};

export default ColoredButton;
